import React, { useState } from "react";
import { Link } from "react-router-dom";
import SupportTicketModal from "./SupportTicketModal";
import { useI18n } from "../i18n";
import { trackModalEvent } from "../utils/analytics";
import "./Footer.css";

function Footer() {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const { t } = useI18n();

  return (
    <>
      <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <span>♥</span>
            TajneMysli
          </div>

          <p>
            {t("footer.description")}
          </p>
        </div>

        <div className="footer-links">
          <div className="footer-column">
            <h3>{t("footer.contact")}</h3>

            <a href="mailto:support@tajnemysli.com">
              support@tajnemysli.com
            </a>

            <button
              className="footer-help-button"
              onClick={() => {
                setIsTicketModalOpen(true);
                trackModalEvent("opened", "support_ticket");
              }}
              aria-label={t("footer.getHelp")}
            >
              ❓ {t("footer.help")}
            </button>
          </div>

          <div className="footer-column">
            <h3>{t("footer.legal")}</h3>

            <Link
              to="/terms"
              onClick={() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
              }}
            >
              {t("footer.terms")}
            </Link>

            <Link
              to="/rules"
              onClick={() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
              }}
            >
              {t("footer.rules")}
            </Link>

            <Link
              to="/about"
              onClick={() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
              }}
            >
              {t("footer.about")}
            </Link>

            <Link
              to="/cookies"
              onClick={() => {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
              }}
            >
              {t("footer.cookies")}
            </Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} {t("footer.copyright")}
        </p>
      </div>
    </footer>

    <SupportTicketModal
      isOpen={isTicketModalOpen}
      onClose={() => {
        setIsTicketModalOpen(false);
        trackModalEvent("closed", "support_ticket");
      }}
    />
    </>
  );
}

export default Footer;
